import { Controller } from "@hotwired/stimulus"

const DEFAULT_DELAY_MS = 600

export default class extends Controller {
  static values = { delay: { type: Number, default: DEFAULT_DELAY_MS } }

  queue() {
    clearTimeout(this.timeout)
    this.timeout = setTimeout(() => this.element.requestSubmit(), this.delayValue)
  }

  disconnect() {
    clearTimeout(this.timeout)
  }
}
